import React, { InputHTMLAttributes } from "react";

interface InputFieldProps extends InputHTMLAttributes<HTMLInputElement> {}
export default function InputField(props: InputFieldProps) {
  return (
    <input className={`w-full form-input  ${props.className}`} {...props} />
  );
}
